/**
 * Global helper to trigger and open Simpel's AI Agent (Simmi).
 * Dispatches a custom event caught by AuraDock and AuraProvider.
 */
export const openAgent = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("open-aura-agent"));
  }
};

export default openAgent;
